export default "__VITE_ASSET__CCpOITw2__"